module.exports = __webpack_public_path__ + "cc399ce03bdcc74fd3f5970bea13c9db.png";